import { Tooltip } from 'bold-ui'
import { isBefore } from 'date-fns'
import React from 'react'

import { AgendaMessages } from './model'

export function AgendaTimeSlotWrapper(props: {
  children: React.ReactNode
  resource: null | /* time slot label */ undefined /* time slot label */
  value: Date
  messages: AgendaMessages
  isAvailable: boolean
  disablePastDates: boolean
}) {
  const { children, resource, isAvailable, value, messages, disablePastDates } = props

  if (resource === undefined) return children as JSX.Element /* time slot label */

  const child: any = React.Children.only(children)
  const classNames = child?.props?.className
  const isPast = isBefore(value, Date.now())

  return (
    <Tooltip placement='bottom' text={isPast && disablePastDates && messages.disabledPastSlot}>
      {React.cloneElement(child, {
        className: `${classNames} rbc-time-slot-${!isAvailable ? 'disabled' : 'available'}`,
      })}
    </Tooltip>
  )
}
